import { createFileRoute, redirect } from "@tanstack/react-router";
import { OrganizationFederationPage } from "@/features/federation/pages/organization-federation-page";
import { fetchOrganizationFederationProviders, federationKeys } from "@/features/federation/queries";
import { sessionQueryKey, type AdminSession } from "@/queries/session";

export const Route = createFileRoute("/_authed/organization/sign-in")({
  beforeLoad: ({ context }) => {
    const session = context.queryClient.getQueryData<AdminSession>(sessionQueryKey);
    if (!session?.admin.organization_id) throw redirect({ to: "/" });
  },
  loader: ({ context }) => {
    const session = context.queryClient.getQueryData<AdminSession>(sessionQueryKey)!;
    return context.queryClient.ensureQueryData({
      queryKey: federationKeys.organization(session.admin.organization_id!),
      queryFn: fetchOrganizationFederationProviders,
    });
  },
  component: OrganizationFederationPage,
});
